import React from "react";
import { FaBuilding, FaCheckCircle } from "react-icons/fa";
import { PageHeader } from "../../shared";

function DealerFirmHeader({
  isLoading,
  totalFirms,
  activeCount = 0,
  myDealerFirm,
  title = "Firma Yönetimi",
  subtitle,
  icon = FaBuilding,
  firmLabel = "Firma",
}) {
  const stats = [
    { icon: FaBuilding, value: totalFirms, label: firmLabel, color: "blue" },
    { icon: FaCheckCircle, value: activeCount, label: "Aktif", color: "emerald" },
  ];

  const resolvedSubtitle =
    subtitle !== undefined
      ? subtitle
      : myDealerFirm
        ? `${myDealerFirm.firmName} - Bayiler ve müşteri yönetimi`
        : "Firma bilgilerini görüntüleyin";

  return (
    <div className="shrink-0">
      <div className="px-3 py-2.5 sm:p-4 md:p-6 bg-gray-50/80 sm:bg-gray-50">
        <PageHeader
          icon={icon}
          iconColor="blue"
          title={title}
          subtitle={resolvedSubtitle}
          stats={stats}
          actions={[]}
          isLoading={isLoading}
          mobileSlotId="firms-toolbar-mobile-slot"
        />
      </div>
    </div>
  );
}

export default DealerFirmHeader;
